import React from "react";

const Car = ({ x, y, rotation }) => {
  // Simple car representation as a rectangle and two wheels
  return (
    <g transform={`translate(${x}, ${y}) rotate(${rotation})`}>
      <rect x={-20} y={-10} width={40} height={20} fill="#3498db" />
      <circle cx={-15} cy={12} r={7} fill="black" />
      <circle cx={15} cy={12} r={7} fill="black" />
    </g>
  );
};

export default Car;